import { getTextsData } from "selectors/texts";
import { getUserData } from "selectors/user";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import DateTimeFormats from "const/DateTimeFormats";
import Dates from "utils/Dates";
import TaskStatuses from "const/TaskStatuses";
import TaskTypes from "const/TaskTypes";
import Texts from "utils/Texts";
import moment from "moment";

const { DATE_TEXT, MONTH_AND_YEAR_TEXT } = DateTimeFormats;

const useTaskContent = (content) => {
  const { status, type, startDate, dueDate, createdBy, createdAt, targetUser } = content || {};

  const { uiTexts } = useSelector(getTextsData);

  const userData = useSelector(getUserData);

  const { id: userId } = useSelector(getUserData);

  const bankFeedsType = type === TaskTypes.BANK_FEEDS;

  const taskCreatedByYou = createdBy && userData.id === createdBy.id;

  const taskForContent = useMemo(() => {
    if (targetUser) {
      if (targetUser.id === userId) return uiTexts.forYou;

      const { fullName: userFullName } = targetUser;

      return Texts.replaceVars(uiTexts.forUserName, { userName: userFullName });
    }

    return uiTexts.forAnyAccountant;
  }, [targetUser, uiTexts, userId]);

  const createdByContent = createdBy ? (taskCreatedByYou ? uiTexts.you : createdBy.fullName) : uiTexts.unknown;

  const today = moment.utc(Dates.formatNoTimeZoneDate(new Date(), false));

  return {
    completed: status === TaskStatuses.COMPLETED,
    dueDateContent: status === TaskStatuses.COMPLETED ? uiTexts.completed.toUpperCase() : (
      !bankFeedsType && dueDate && moment(dueDate).format(DATE_TEXT)
    ),
    dueDateStatus: (status !== TaskStatuses.COMPLETED) && !bankFeedsType && dueDate && (
      moment(dueDate).isSameOrBefore(today.startOf("day")) ? "negative"
        : (moment(dueDate).isAfter(today.add(1, "day").endOf("day")) ? null : "warning")
    ),
    taskForContent,
    createdAtContent: !bankFeedsType && moment.duration(moment(createdAt).diff(moment())).humanize(true),
    startDateContent: !bankFeedsType && startDate && (
      type === TaskTypes.CUSTOM ? moment(startDate).format(DATE_TEXT) : moment.utc(startDate).format(MONTH_AND_YEAR_TEXT)),
    createdByContent
  };
};

export default useTaskContent;
